import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';
import { MissingTranslationHandler, TranslateLoader } from '@ngx-translate/core';
import * as Hammer from 'hammerjs';
import { CustomMissingTranslationHandler, TranslationHttpLoader } from 'src/core-lib/misselaineous/missing-translation-handler';



// tslint:disable: max-line-length

export const config = {

    svgDef: {},
    translate: {
        loader: {
            provide: TranslateLoader,
            useFactory: (http) => TranslationHttpLoader(http),
            deps: [HttpClient]
        },
        missingTranslationHandler: {
            provide: MissingTranslationHandler,
            useClass: CustomMissingTranslationHandler
        },
        defaultLanguage: 'da-dk',
        useDefaultLang: true
    },

};

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
    overrides = {
        pinch: { enable: false },
        rotate: { enable: false },
        swipe: { direction: Hammer.DIRECTION_HORIZONTAL },
        // 'touchAction': 'auto',
    };
}
